import * as React from 'react';
import {Box as MuiBox} from '@mui/material';


const Item = (props: any) => {
    return <MuiBox {...props} />
}

export default Item;